import useAxiosInterceptor from 'src/services/interceptor';
import { MyAvailability } from '../constants';

const { getAllPtoRequest, createPtoRequest, removePtoRequest } = MyAvailability;

interface PtoRequestType {
  description: string;
  allDay: boolean;
  startDate: string;
  endDate: string;
}

class PtoRequestService {
  private axiosInstance;

  constructor() {
    this.axiosInstance = useAxiosInterceptor();
  }

  getAllPtoRequest = (providerId: string) => {
    return this.axiosInstance.get(`${getAllPtoRequest}/${providerId}`);
  };

  createPtoRequest = (payload: PtoRequestType, providerId: string) => {
    return this.axiosInstance.post(`${createPtoRequest}/${providerId}`, payload);
  };

  removePtoRequest = (providerId: string) => {
    return this.axiosInstance.delete(`${removePtoRequest}/${providerId}`);
  };
}

const ptoRequestServices = new PtoRequestService();

Object.freeze(ptoRequestServices);

export default ptoRequestServices;
